import requestCtxs from '@/sealFilter/requestCtxs'

//获取电子资源信息
export function queryDianziResourceCondition(data) {
    return requestCtxs({
        url: '/whgs/api/queryDianziResourceCondition ',
        method: 'post',
        data
    })
}

//添加或更新电子咨源
export function InserOrUpdatedianziResource(data) {
    return requestCtxs({
        url: '/whgs/api/InserOrUpdatedianziResource ',
        method: 'post',
        data
    })
}

// 删除电子资源
export function DeletedzResource(data) {
    return requestCtxs({
        url: '/whgs/api/DeletedzResource',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/dainziBook.js